module.exports = __webpack_public_path__ + "img/30.802b31e6.jpg";